/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { ProductIcon } from '../../Assets/AllSvg'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiOutlinePlusSm } from 'react-icons/hi'
import { BsThreeDots } from 'react-icons/bs'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { useNavigate } from 'react-router'
import ArchiveProductModal from '../ArchiveProductModal/ArchiveProductModal'
import DeleteProductModal from '../DeleteProductModal/DeleteProductModal'
import { GetProducts } from '../API/ProductAPI'
import moment from 'moment'
import { GetPrice } from '../API/PriceAPI'
import ProductImage from './ProductImage'

const ProductsAll = () => {
    const [product, setProduct] = useState("available")
    const [active, setActive] = useState(false)
    const [delProduct, setDelProduct] = useState(false)
    const [sendData, setSendData] = useState('')
    const [productData, setProductData] = useState([])
    const [deleteProduct, setDeleteProduct] = useState('')
    const [prodDel, setProdDel] = useState(false)
    const [priceList, setPriceList] = useState([])

    const navigate = useNavigate()

    const handleNavDetail = (id) => {
        navigate(`/product/${id}`)
    }

    const getProduct = async () => {
        const result = await GetProducts()

        const userID = localStorage.getItem("user")
        setProductData(result && result.filter((val) => val.user_id === userID))

        const price = await GetPrice()
        setPriceList(price)
    }

    const getPrice = (productId) => {
        const data = priceList.filter((val) => val.product_id === productId)
        if(data.length !== 0){
            if(data.length > 1){
                return `${data.length} prices`
            } else {
                const billing = data[0].billing_period ? data[0].billing_period : 'month'
                const finalStr = `$${data[0].price_data}.00 ${data[0].select_currency} / ${billing}`
                return  finalStr
            }
        }
    }

    useEffect(() => {
        getProduct()
    }, [prodDel])

    return (
        <>
            <div>
                <div className="mt-3 grid grid-cols-3 gap-2 text-sm">
                    <button
                        className={`${product === "all"
                            ? "text-[#625afa] border-[#625afa] border-[2px] font-semibold"
                            : "border-[1px] border-[#d5dbe1] font-normal text-[#414552]"
                            } p-[11px] rounded-[8px] text-start`}
                        onClick={() => setProduct("all")}
                    >
                        All
                    </button>
                    <button
                        className={`${product === "available"
                            ? "text-[#625afa] border-[#625afa] border-[2px] font-semibold"
                            : "border-[1px] border-[#d5dbe1] font-normal text-[#414552]"
                            } p-[11px] rounded-[8px] text-start`}
                        onClick={() => setProduct("available")}
                    >
                        Available
                    </button>
                    <button
                        className={`${product === "archived"
                            ? "text-[#625afa] border-[#625afa] border-[2px] font-semibold"
                            : "border-[1px] border-[#d5dbe1] font-normal text-[#414552]"
                            } p-[11px] rounded-[8px] text-start`}
                        onClick={() => setProduct("archived")}
                    >
                        Archived
                    </button>
                </div>
                {productData.length !== 0 ? (
                    <div className="w-full mt-5">
                        <div className='w-full overflow-x-auto'>
                            <table className="table-auto product-table sm:w-full w-[610px] overflow-x-auto">
                                <thead>
                                    <tr className="border-b-[1px] border-[#ebeef1]">
                                        <th className="text-[#1a1b25] text-[11px] px-[12px] py-[8px] font-medium text-start"></th>
                                        <th className="text-[#1a1b25] text-[11px] px-[12px] py-[8px] font-medium text-start w-full">
                                            NAME
                                        </th>
                                        <th className="text-[#1a1b25] text-[11px] px-[12px] py-[8px] font-medium text-start">
                                            CREATED
                                        </th>
                                        <th className="text-[#1a1b25] text-[11px] px-[12px] py-[8px] font-medium text-start">
                                            UPDATED
                                        </th>
                                        <th className="text-[#1a1b25] text-[11px] px-[12px] py-[8px] font-medium text-start"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productData.map((val) => (
                                        <tr key={val.product_id} className="border-b-[1px] border-[#ebeef1] hover:bg-[#f6f8fa]">
                                            <td
                                                className="px-[12px] py-[16px] cursor-pointer"
                                                onClick={() => handleNavDetail(val.product_id)}
                                            >
                                                <div className="w-max bg-[#f7fafc80]">
                                                    <ProductImage product={val}/>
                                                </div>
                                            </td>
                                            <td
                                                className="px-[12px] py-[16px] text-sm cursor-pointer"
                                                onClick={() => handleNavDetail(val.product_id)}
                                            >
                                                <h3 className="text-[#414552]">{val.name}</h3>
                                                <p className="text-[#687385]">{getPrice(val.product_id)}</p>
                                            </td>
                                            <td
                                                className="px-[12px] whitespace-nowrap py-[16px] text-sm text-center cursor-pointer"
                                                onClick={() => handleNavDetail(val.product_id)}
                                            >
                                                {moment(val.inserted_dt).format("MMMM DD")}
                                            </td>
                                            <td
                                                className="px-[12px] py-[16px] text-sm text-center cursor-pointer"
                                                onClick={() => handleNavDetail(val.product_id)}
                                            >
                                                {moment(val.updated_dt).format("MMMM DD")}
                                            </td>
                                            <td className="px-[12px] py-[16px] text-sm pl-[50px] relative z-50">
                                                <Menu placement="bottom-end">
                                                    <MenuHandler>
                                                        <button className="px-2 py-1 hover:bg-white rounded-md">
                                                            <BsThreeDots />
                                                        </button>
                                                    </MenuHandler>
                                                    <MenuList className="px-0 py-2 mt-2 min-w-[168px] outline-remove">
                                                        <MenuItem
                                                            onClick={() => navigate(`/product/edit?id:${val.product_id}`)}
                                                            className="text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none"
                                                        >
                                                            Edit product
                                                        </MenuItem>
                                                        <hr className="my-1" />
                                                        <MenuItem
                                                            onClick={() => { setActive(!active); setSendData('product') }}
                                                            className="text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none"
                                                        >
                                                            Archive product
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={() => {
                                                                setDelProduct(true);
                                                                setDeleteProduct(val);
                                                                setSendData('product')
                                                            }}
                                                            className="text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none"
                                                        >
                                                            Delete Product
                                                        </MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="flex justify-between items-center mt-2">
                            <span className="text-[#687385] text-sm">
                                <b>{productData.length}</b> results
                            </span>
                            <div className="flex gap-2">
                                <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60">
                                    Previous
                                </button>
                                <button
                                    className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60"
                                    disabled=""
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="h-[564px] flex items-center justify-center">
                        <div className="p-[64px]">
                            <div className="p-[12px] w-max rounded-[8px] bg-[#f6f8fa]">
                                <ProductIcon className="fill-gray-500 w-[23px] h-[23px]" />
                            </div>
                            <div className="mt-6">
                                <span className="text-[20px] font-bold text-[#1a1b25]">
                                    {product === "archived"
                                        ? "No test products found for applied filters"
                                        : "Add your first test product"}
                                </span>
                            </div>
                            <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">
                                {product === "archived"
                                    ? "You can try changing your filters or switching to live mode to expand your results. Otherwise, you can create a product"
                                    : "Products are what you sell to customers. They can be anything from physical goods to digital services or subscription plans."}
                            </p>
                            {product === "archived" ? null : (
                                <button className="text-[#625afa] mt-1 flex items-center font-medium gap-1 text-sm">
                                    Learn more
                                    <BiRightArrowAlt className="text-[20px] translate-y-[2px]" />
                                </button>
                            )}
                            <button className="flex gap-1 mt-5 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]">
                                <HiOutlinePlusSm className="text-[22px]" />
                                Add a product{" "}
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <ArchiveProductModal active={active} setActive={setActive} sendData={sendData} />
            <DeleteProductModal
                delProduct={delProduct}
                setDelProduct={setDelProduct}
                deleteProduct={deleteProduct}
                setDeleteProduct={setDeleteProduct}
                prodDel={prodDel}
                setProdDel={setProdDel}
                sendData={sendData}
            />
        </>
    );
}
export default ProductsAll